import React from "react";

const AllStores = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 2.00004V0.333374H14.6667V2.00004H1.33333ZM1.33333 13.6667V8.66671H0.5V7.00004L1.33333 2.83337H14.6667L15.5 7.00004V8.66671H14.6667V13.6667H13V8.66671H9.66667V13.6667H1.33333ZM3 12H8V8.66671H3V12ZM2.20833 7.00004H13.7917L13.2917 4.50004H2.70833L2.20833 7.00004Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AllStores;
